import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './locales/pt.json';
import en from './locales/en.json';
import ptTournaments from './locales/pt-tournaments.json';
import enTournaments from './locales/en-tournaments.json';

// Migration silent: usuários antigos persistiram 'pt-BR' em localStorage
// (legado pré-QW-7). Convertemos para 'pt' antes do init para evitar flicker
// e fallback para inglês. Locale i18n unificado em 'pt' nos 4 apps.
// Mantemos 'pt-BR' apenas em Intl APIs (formatação de número/data) — ver IR-UX-005.
try {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem('i18nextLng');
    if (stored === 'pt-BR') {
      window.localStorage.setItem('i18nextLng', 'pt');
    }
  }
} catch {
  // localStorage indisponível (SSR / privacidade) — ignorar.
}

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: pt, tournaments: ptTournaments },
    en: { translation: en, tournaments: enTournaments },
  },
  lng: 'pt',
  fallbackLng: 'pt',
  // Sem `ns` + `defaultNS` explicitos, react-i18next nao registra `tournaments`
  // no namespace-store no boot e `useTranslation("tournaments")` retorna a chave
  // literal (ex.: "brackets.emptyBracket") nas primeiras renders do bracket vazio
  // — bug observado em smoke HML 2026-05-19 mesmo com PR #341 mergeado.
  // Alinhado com apps/public/src/i18n/index.ts (que ja declara explicitamente).
  defaultNS: 'translation',
  ns: ['translation', 'tournaments'],
  interpolation: { escapeValue: false },
});

export default i18n;
